import Link from 'next/link';
import Image from '@/components/Image';
import { FaYoutube, FaInstagram, FaTiktok } from 'react-icons/fa6';

const footerGroups = [
  {
    title: 'Learn',
    links: [
      { label: 'Textbooks', href: '/textbooks' },
      { label: 'Roadmaps', href: '/roadmaps' },
    ],
  },
  {
    title: 'Solutions',
    links: [
      { label: 'AI Tutor for Kids', href: '/ai-tutor-for-kids' },
      { label: 'AI Homework Helper', href: '/ai-homework-helper' },
      { label: 'AMC 8 Prep', href: '/amc-8-prep' },
      { label: 'No-Answer Homework Help', href: '/homework-help-without-giving-answers' },
      { label: 'Textbook-Aligned AI Tutor', href: '/textbook-aligned-ai-tutor' },
      { label: 'AI Tutor for Scratch', href: '/scratch-ai-tutor' },
      { label: 'AI Tutor for PhET', href: '/phet-ai-tutor' },
      { label: 'AI Tutor for IXL & Khan', href: '/ixl-khan-ai-tutor' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Blog', href: '/blog' },
      { label: 'Subjects', href: '/subjects' },
      { label: 'Search', href: '/search' },
      { label: 'About', href: '/about' },
    ],
  },
];

const socialLinks = [
  { label: 'YouTube', href: 'https://www.youtube.com/@Pengi_ai', icon: FaYoutube },
  { label: 'Instagram', href: 'https://www.instagram.com/pengi.ai/', icon: FaInstagram },
  { label: 'TikTok', href: 'https://www.tiktok.com/@pengi_yourcutestudybuddy', icon: FaTiktok },
];

export default function PublicSiteFooter() {
  return (
    <footer className="w-full border-t border-[#D7D9E0] bg-[linear-gradient(180deg,#ffffff_0%,#f7fbff_100%)]">
      <div className="mx-auto flex w-full max-w-[1440px] flex-col gap-12 px-6 py-14 lg:px-10">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          <div className="max-w-[420px]">
            <Link href="/" className="flex items-center gap-4">
              <Image
                src="/assets/landing-logo.png"
                alt="Pengi"
                width={48}
                height={48}
                optimizedWidth={96}
              />
              <span className="emphasize-text text-3xl font-bold text-[#1F2A44]">Pengi</span>
            </Link>
            <div className="mt-5 flex flex-wrap items-center gap-3">
              {socialLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={link.label}
                  className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-[#D7D9E0] bg-white text-[#4D5059] transition hover:border-[#42C52D] hover:text-[#42C52D]"
                >
                  <link.icon className="h-5 w-5" />
                </a>
              ))}
            </div>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {footerGroups.map((group) => (
              <div key={group.title} className="min-w-[170px]">
                <h3 className="display-text-semi text-sm uppercase tracking-[0.18em] text-[#8A94AB]">
                  {group.title}
                </h3>
                <div className="mt-4 flex flex-col gap-3">
                  {group.links.map((link) => (
                    <Link
                      key={link.href}
                      href={link.href}
                      className="display-text text-base text-[#1F2A44] transition-colors hover:text-[#42C52D]"
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-4 border-t border-[#E3E8F2] pt-6 text-sm text-[#6B7280] md:flex-row md:items-center md:justify-between">
          <div className="display-text">
            © 2026 Pengi. Built for students, parents, and educators.
          </div>
          <div className="display-text flex items-center gap-4 self-end text-sm text-[#6B7280]">
            <Link href="/privacy-policy" className="transition-colors hover:text-[#42C52D]">
              Privacy Policy
            </Link>
            <Link href="/terms" className="transition-colors hover:text-[#42C52D]">
              Terms of Use
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
